import { Button, Layout, Menu, theme, Form, Typography, Input, Modal, Popconfirm, notification, Spin, Row, Col } from "antd";

import React, { useState, useEffect, useCallback, useRef } from "react";
import "../CreateRole/CreateRole.css";
import axios from "axios";
import {
    CameraOutlined, ContactsOutlined, UserOutlined
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import { useForm, Controller } from "react-hook-form";
import UserApi from "../../common/Apis/UserApi";
import { Tabs } from 'antd';
import UserContactApi from "../../common/Apis/UserContactApi";
import { DeleteOutlined } from "@ant-design/icons";
import Contact from "../../common/Models/Contact/Contact";

const { Title } = Typography;
const ManageAccount = () => {
    const navigate = useNavigate();
    const { Content } = Layout;
    const [loadings, setLoadings] = useState(false);
    const [formAccount] = Form.useForm();
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
    const [userDetails, setUserDetails] = useState(UserDetails);
    const SelectedProfile = JSON.parse(localStorage.getItem("SelectedProfile"));
    const [selectedMenuItem, setSelectedMenuItem] = useState("1");
    const splitName = decodedToken?.name.split(" ");
    const [firstName, setfirstName] = useState("");
    const { TabPane } = Tabs;

    // console.log("toekn", localStorage.getItem("decodedToken"));


    const {
        control,
        handleSubmit,
        formState: { errors, isSubmitSuccessful },
    } = useForm();
    const {
        token: { colorBgContainer },
    } = theme.useToken();
    const [src, setSrc] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const cropperRef = useRef(null);
    const onSelectFile = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.onload = () => setSrc(reader.result);
            reader.readAsDataURL(e.target.files[0]);
            setIsModalVisible(true);
        }
    };
    const closeModal = () => {
        setIsModalVisible(false);
    };

    useEffect(() => {

        if (decodedToken) {
            formAccount.setFieldsValue({
                firstName: splitName[0],
                lastName: splitName[1],
                email: decodedToken?.sub,
            });

            setfirstName(splitName[0]?.charAt(0));
        } else {
            return navigate("/");
        }
    }, [decodedToken, UserDetails, splitName, navigate]);

    const getCroppedData = async () => {
        const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas();

        const croppedBlob = await new Promise((resolve) => {
            croppedCanvas.toBlob((blob) => {
                resolve(blob);
            }, "image/jpeg");
        });
        const uniqueId = `${Date.now()}_${new Date().getSeconds()}`;
        const originalFileName = src.substring(src.lastIndexOf("/") + 1);
        const newFileName = `${uniqueId}_${originalFileName}`;

        const token = localStorage.getItem("UserjwtToken");
        const formData = new FormData();
        const selected = true;
        formData.append("file", croppedBlob, newFileName);
        formData.append("tenantId", decodedToken?.tenantId);
        formData.append("tenantDTO", {
            id: decodedToken?.tenantId,
            tenantApiKey: decodedToken?.tenantApiKey,
        });
        let url = `http://iva-api-dev-681889668.eu-west-1.elb.amazonaws.com:8080/api/v1/user-profile/file-resources/uploads?tenantId=${decodedToken?.tenantId}&userId=${UserDetails?.id}&selected=${selected}`;
        let headers = {
            Authorization: `Bearer ${token}`,
            "x-Authorization": `${decodedToken?.tenantApiKey}`,
        };
        axios
            .post(url, formData, {
                headers: headers,
            })
            .then((res) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Upload</span>,
                    description: "Upload Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                setTimeout(() => {
                    window.location.reload();
                }, 600);
            })
            .catch((err) => {
                console.log(err);
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Error</span>,
                    description: err?.response?.data?.apiError?.message,
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#fff2f0",
                        color: "red",
                    },
                });
            });
        closeModal();
    };
    const handleSubmitForm = (data) => {
        const role = decodedToken?.roles?.[0];
        const roleMap = {
            TENANT_ADMIN: 3,
            SUB_TENANT_ADMIN: 4,
            MANAGER: 6,
            SUPERVISOR: 7,
            SYSTEM_USER: 2,
        };

        let formData = JSON.stringify({
            id: decodedToken?.userId,
            firstName: data?.firstName,
            lastName: data?.lastName,
            email: data?.email,
            enabled: true,
            tenantDTO: {
                id: decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
            roleDTOs: role && roleMap[role] ? [{ id: roleMap[role] }] : [],
        });
        UserApi.UserDetailsUpdate(decodedToken?.userId, formData)
            .then((response) => {
                setLoadings(false);

                formAccount.setFieldsValue({
                    firstName: response?.payload?.firstName,
                    lastName: response?.payload?.lastName,
                    email: response?.payload?.email,
                });

                localStorage.setItem("decodedToken", JSON.stringify({ ...JSON.parse(localStorage.getItem("decodedToken")), name: response?.payload?.firstName + " " + response?.payload?.lastName }));

                // }

                //     setfirstName(splitName[0]?.charAt(0));
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
                    description: "Update Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });

                // setTimeout(() => {
                //     window.location.reload();
                // }, 600);
            })
            .catch((err) => {
                if (err.apiError.status) {
                    setLoadings(false);
                    notification.open({
                        message: <span style={{ fontWeight: "bold" }}>Error</span>,
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });
    };
    // useEffect(() => {
    //     const headers = {
    //         Authorization: `Bearer ${token}`,
    //         "x-Authorization": `${decodedToken?.tenantApiKey}`,
    //     };

    //     // Fetch user data from the API
    //     axios.get('http://iva-api-dev-681889668.eu-west-1.elb.amazonaws.com:8080/api/v1/user', {
    //         headers: headers,
    //     })
    //     .then(response => {
    //         const data = response.data;
    //         console.log(data);

    //         // Set the form fields with the fetched data
    //         Form.setFieldsValue({
    //             firstName: data.firstName,
    //             lastName: data.lastName,
    //             email: data.email
    //         });
    //     })
    //     .catch(error => {
    //         console.error('Error fetching user data:', error);
    //     });
    // }, [Form, token, decodedToken]);

    const handleGoBack = () => {
        navigate(-1);
    };


    const [Contacts, setContacts] = React.useState([]);


    const getContacts = useCallback(() => {
        UserContactApi.ListUserContactApi()
            .then((response) => {
                setContacts(response?.payloadDto);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    useEffect(() => {
        getContacts();
    }, [getContacts]);


    const handleDeleteContact = (ContactID) => {
        UserContactApi.DeleteContactsApi(ContactID)
            .then((response) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
                    description: "Delete Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                getContacts();
            })
            .catch((err) => {
                if (err.apiError.status) {
                    notification.open({
                        message: <span style={{ fontWeight: "bold" }}>Error</span>,
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });
    };



    const [activeTab, setActiveTab] = useState('account'); // Default active tab

    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    const handleButtonClickTap = (key) => {
        setActiveTab(key);
    };
    const handleMenuClick = (menuItem) => {
        setSelectedMenuItem(menuItem.key);
    };

    const [modalContactVisible, setModalContactVisible] = useState(false);

    const handleOpenContactModal = () => {
        setModalContactVisible(true);
    };
    const handlContactCloseModal = () => {
        setModalContactVisible(false);
        getContacts();
    };
    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader />

                <Row gutter={24}>
                    <Col lg={6} md={24}>
                        <Content
                            className="form-content nav-content"
                            style={{
                                margin: "16px 16px 16px 16px",
                                paddingBottom: "100px",
                                marginRight: '0px',
                                padding: "15px",
                                background: colorBgContainer,
                            }}
                        >
                            <Menu
                                theme="dark"
                                className="userManage"
                                style={{
                                    height: "100%",
                                    paddingLeft: "7px",
                                    paddingRight: "7px",
                                    backgroundColor: "white"
                                }}
                                mode="inline"
                                selectedKeys={[selectedMenuItem]}
                                onClick={handleMenuClick}
                            >
                                <Menu.Item key="1" icon={<UserOutlined />}>
                                    <Link to={""} onClick={() => handleButtonClickTap('account')}>Personal Info</Link>
                                </Menu.Item>



                                <Menu.Item key="2" icon={<ContactsOutlined />}>
                                    <Link to={""} onClick={() => handleButtonClickTap('Contacts')}>Contacts</Link>
                                </Menu.Item>
                            </Menu>

                        </Content>
                    </Col>
                    <Col lg={18} md={24}>
                        <Content
                            className="form-content nav-content"
                            style={{
                                margin: "16px 16px 0",
                                padding: "30px",
                                marginLeft: '0px',
                                paddingBottom: "100px",
                                background: colorBgContainer,
                            }}
                        >

                            <Tabs activeKey={activeTab} onChange={handleTabChange}>
                                <TabPane key="account">
                                    <Row gutter={24} >
                                        <Col lg={6} md={24} className="d-flex" style={{ justifyContent: 'center' }}>
                                            <Controller
                                                name="uploadFile"
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <>
                                                        <input
                                                            type="file"
                                                            id="fileInput"
                                                            style={{ visibility: "hidden", display: "none" }}
                                                            onChange={onSelectFile}
                                                            accept="image/*"
                                                        />
                                                        <div className="MAccount" style={{ display: "flex", alignItems: "center" }}>
                                                            <div className="circle-image-container">
                                                                {SelectedProfile && SelectedProfile[0]?.fileDownloadUri ? (
                                                                    <label htmlFor="fileInput"><img
                                                                        src={SelectedProfile[0]?.fileDownloadUri}
                                                                        className="circle-image"
                                                                        style={{
                                                                            width: "80%",
                                                                            borderRadius: "50%",
                                                                            // background:
                                                                            //   "conic-gradient(yellowgreen, 25%, blue 0 50%,yellow 0 75%,red 0 10%)",
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            fontWeight: "bold",
                                                                            padding: "3px",
                                                                            color: "#fff",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    /></label>
                                                                ) : (

                                                                    <label htmlFor="fileInput">  <div
                                                                        className="circle-image"
                                                                        style={{
                                                                            borderRadius: "50%",
                                                                            background: "#001529",
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            fontWeight: "bold",
                                                                            padding: "5px",
                                                                            color: "#fff",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        <p> {firstName}</p>
                                                                    </div></label>
                                                                )}
                                                                <label htmlFor="fileInput">      <div className="camera-icon" >
                                                                    <CameraOutlined />
                                                                </div></label>
                                                            </div>

                                                        </div>


                                                        <Modal
                                                            title="Crop Image"
                                                            visible={isModalVisible}
                                                            onOk={getCroppedData}
                                                            okText="Upload"
                                                            maskClosable={false}
                                                            onCancel={closeModal}
                                                        >
                                                            {src && (
                                                                <Cropper
                                                                    ref={cropperRef}
                                                                    src={src}
                                                                    aspectRatio={1}
                                                                    style={{ height: 300, width: "100%" }}
                                                                    cropShape="round"
                                                                />
                                                            )}
                                                        </Modal>
                                                    </>
                                                )}
                                            />
                                        </Col>

                                        <Col lg={18} md={24} >
                                            <Form
                                                form={formAccount}
                                                name="nest-messages"
                                                layout="vertical"
                                                className="FormClass"
                                                onFinish={handleSubmitForm}
                                            >
                                                <>
                                                    <Row gutter={24}>
                                                        <Col lg={11} md={24}>
                                                            <Form.Item
                                                                name="firstName"
                                                                label="First Name"
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please enter First Name.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    type="text"
                                                                    placeholder="First Name"
                                                                    className="control-input"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col lg={11} md={24}>
                                                            <Form.Item
                                                                name="lastName"
                                                                label="Last Name"
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please Last Name.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    type="text"
                                                                    placeholder="Last Name"
                                                                    className="control-input"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col lg={11} md={24}>
                                                            <Form.Item
                                                                name="email"
                                                                label="Email"
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please enter Email.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    type="email"
                                                                    readOnly
                                                                    placeholder="Email"
                                                                    className="control-input"
                                                                />
                                                            </Form.Item>
                                                        </Col>

                                                        <Col lg={14} md={24}>
                                                            <div className="d-flex justify-content-start">
                                                                <Link
                                                                    type="primary"
                                                                    to={""}
                                                                    onClick={handleGoBack}
                                                                    className="btn btn-primary btn-back"
                                                                >
                                                                    Back
                                                                </Link>

                                                                <Button
                                                                    type="primary"
                                                                    htmlType="submit"
                                                                    className="btn btn-primary btn-save"
                                                                >
                                                                    Save Changes {loadings == true && <Spin className="px-2" />}
                                                                </Button>
                                                            </div></Col>
                                                    </Row>


                                                </>
                                            </Form></Col></Row>
                                </TabPane>
                                <TabPane key="Contacts">
                                    <Row gutter={24}>
                                        <Col lg={3} md={24}></Col>
                                        <Col lg={18} md={24}>
                                            <Title level={4} className="text-center Primary-Font mb-0 ">
                                                User Contacts
                                            </Title>


                                            <div className="d-flex justify-content-center ">
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    className={decodedToken?.permissions?.some(
                                                        (permission) => permission?.authority === 'ADD_USER_CONTACT'
                                                    ) ? 'btn btn-primary btn-save mx-2' : 'd-none'}
                                                    style={{ width: "37%" }}
                                                    onClick={handleOpenContactModal}
                                                >
                                                    Add
                                                </Button>

                                            </div>

                                            <table className="table users-table pt-4">
                                                <thead>
                                                    <tr>
                                                        <th>Type</th>
                                                        <th>Contact Value</th>
                                                        <th className="text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Contacts && (
                                                        <>
                                                            {Contacts.length > 0 ? (
                                                                <>
                                                                    {Contacts.reverse().map((item) => (
                                                                        <tr key={item?.id} className="text-center">
                                                                            <td style={{ width: "22%" }} className="pt-3">
                                                                                {item?.contactType}
                                                                            </td>

                                                                            <td style={{ width: "40%" }} className="pt-3">
                                                                                {item?.contactValue}
                                                                            </td>

                                                                            <td style={{ width: "20%" }}>
                                                                                <div className="d-flex ">
                                                                                    <Popconfirm
                                                                                        title="Are you sure ?"
                                                                                        description="Do you really want to delete this User Contact ?"
                                                                                        okText="Yes"
                                                                                        onConfirm={() => handleDeleteContact(item.id)}
                                                                                        placement="topRight"
                                                                                        className="w-100"
                                                                                        cancelText="No"
                                                                                    >
                                                                                        <Link
                                                                                            to={``}
                                                                                            className="btn btn-primary btn-back table-action icon-center mx-1"
                                                                                        >
                                                                                            <DeleteOutlined />
                                                                                            Delete
                                                                                        </Link>
                                                                                    </Popconfirm>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <tr className="text-center EmptyTable">
                                                                        <td colSpan={3} className="text-center ">
                                                                            <img
                                                                                src="/assest/Images/emptyIcon.svg"
                                                                                className="logo-png mt-3"
                                                                                style={{ width: "15%" }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </tbody>
                                            </table>
                                        </Col>
                                        <Col lg={3} md={24}></Col>
                                    </Row>

                                </TabPane>
                            </Tabs>



                        </Content>

                    </Col>

                </Row>

                <Contact visible={modalContactVisible} onClose={handlContactCloseModal} />
                {/* <FooterDashboard /> */}
            </Layout>
        </Layout>
    );
};
export default ManageAccount;
